import { render } from "./SearchCriteria.vue?vue&type=template&id=64507647"
import script from "./SearchCriteria.vue?vue&type=script&lang=js"
export * from "./SearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__